import { styled } from '@mui/material/styles';

const filledInput = {
  '& .MuiFormControl-root': {
    margin: 0,
    width: '100%',
  },
  '& .MuiAutocomplete-root': {
    width: '100%',
  },
  '& .MuiOutlinedInput-root': {
    width: '100%',
    maxWidth: '100%',
  },
  '& .MuiFormHelperText-root': {
    marginLeft: 0,
    marginRight: 0,
    marginTop: '6px',
  },
};

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  width: '100%',
  marginBottom: '20px',
  ...filledInput,
});

export const Pair = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '16px',
  alignItems: 'start',
  [theme.breakpoints.down(720)]: {
    gridTemplateColumns: '1fr',
  },
}));
